// The ONLY file that touches PDF.js, so the rest of the app (and the Jest tests) never load it.
import * as pdfjsLib from 'pdfjs-dist/build/pdf';

// The worker file must be the same version as pdfjs-dist; webpack copies it next to the bundle.
// @ts-ignore import.meta is handled by webpack, TypeScript here is set to es6 modules
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

export interface LoadedPdf {
  pageCount: number;
  renderPage: (pageNumber: number, canvas: HTMLCanvasElement, scale: number) => Promise<void>;
  destroy: () => void;
}

export const loadPdf = async (url: string): Promise<LoadedPdf> => {
  const doc = await pdfjsLib.getDocument({ url, withCredentials: true }).promise;

  return {
    pageCount: doc.numPages,
    renderPage: async (pageNumber, canvas, scale) => {
      const page = await doc.getPage(pageNumber);
      const viewport = page.getViewport({ scale });
      const context = canvas.getContext('2d');
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      await page.render({ canvasContext: context, viewport }).promise;
    },
    destroy: () => { doc.destroy(); },
  };
};
